export enum GoalDiffAction {
    SET_VALUE = 1,
    UPDATE_VALUE,
    UPDATE_EXPECTED_ACHIEVEMENT_DATE,
    CLOSE,
}
